import React from "react";

const iconProps = {
  width: 14,
  height: 14,
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

export const PersonIcon = () => (
  <svg {...iconProps}>
    <circle cx="8" cy="5.5" r="2.5" />
    <path d="M3 13.5C3 11 5 9.5 8 9.5C11 9.5 13 11 13 13.5" />
  </svg>
);

export const DollarIcon = () => (
  <svg {...iconProps}>
    <path d="M8 2v12" />
    <path d="M11 5.5C11 4.4 10 3.5 8 3.5C6 3.5 5 4.4 5 5.5C5 6.6 6 7.2 8 7.7C10 8.2 11 8.8 11 10.2C11 11.4 10 12.5 8 12.5C6 12.5 5 11.4 5 10.2" />
  </svg>
);

export const CardIcon = () => (
  <svg {...iconProps}>
    <rect x="2" y="4" width="12" height="9" rx="1.5" />
    <path d="M2 7H14" />
    <path d="M5 10.5H7" />
  </svg>
);

export const BankIcon = () => (
  <svg {...iconProps}>
    <path d="M2 6.5L8 3L14 6.5" />
    <path d="M3 6.5V12.5M6 6.5V12.5M10 6.5V12.5M13 6.5V12.5" />
    <path d="M2 13H14" />
  </svg>
);

export const HashIcon = () => (
  <svg {...iconProps}>
    <path d="M5.5 2L4 14" />
    <path d="M12 2L10.5 14" />
    <path d="M2.5 5.5H13.5" />
    <path d="M2 10.5H13" />
  </svg>
);

export const CalendarIcon = () => (
  <svg {...iconProps}>
    <rect x="2.5" y="3.5" width="11" height="10" rx="1" />
    <path d="M2.5 6.5H13.5" />
    <path d="M5.5 2V5" />
    <path d="M10.5 2V5" />
  </svg>
);

export const TagIcon = () => (
  <svg {...iconProps}>
    <path d="M8.5 2H13V6.5L7 12.5L2.5 8L8.5 2Z" />
    <circle cx="10.5" cy="4.5" r="0.75" fill="currentColor" stroke="none" />
  </svg>
);

export const StatusIcon = () => (
  <svg {...iconProps}>
    <circle cx="8" cy="8" r="5.5" />
    <path d="M5.5 8L7 9.5L10.5 6" />
  </svg>
);

export const ChannelIcon = () => (
  <svg {...iconProps}>
    <path d="M2.5 5H10.5L8.5 3" />
    <path d="M2.5 5L4.5 7" />
    <path d="M13.5 11H5.5L7.5 13" />
    <path d="M13.5 11L11.5 9" />
  </svg>
);

export const CycleIcon = () => (
  <svg {...iconProps}>
    <path d="M3 8C3 5.2 5.2 3 8 3C10 3 11.7 4.2 12.5 6" />
    <path d="M12.5 3.5V6H10" />
    <path d="M13 8C13 10.8 10.8 13 8 13C6 13 4.3 11.8 3.5 10" />
    <path d="M3.5 12.5V10H6" />
  </svg>
);

const CHIP_ICONS = {
  accountNumber: HashIcon,
  amount: DollarIcon,
  bankAccountHolderName: PersonIcon,
  bankLastFour: BankIcon,
  cardholderName: PersonIcon,
  cardLastFour: CardIcon,
  transactionId: HashIcon,
  agencies: PersonIcon,
  serviceType: TagIcon,
  paymentStatus: StatusIcon,
  paymentChannel: ChannelIcon,
  paymentMethod: CardIcon,
  paymentSource: BankIcon,
  paymentMode: CycleIcon,
  date: CalendarIcon,
};

export default CHIP_ICONS;
